import React, { memo } from 'react';
import { useTheme } from 'ThemeContext';
import DOMPurify from 'dompurify';
import htmlParser from 'react-html-parser';
import useStyle from 'helpers/useStyle';
import useScript from 'helpers/useScript';

import { Breakpoints } from 'assets/Variables.style';

import {
  Wrapper,
  Content,
  ItemExternal,
  Item,
  Imagebox,
  Source,
  Image
} from './WidgetAdvertisement.style';

function WidgetAdvertisement({ data = {} }) {
  const theme = useTheme();
  const [styleRef] = useStyle(data.style);
  const [scriptRef] = useScript(data.script);

  const renderItemInner = () => {
    return (
      <>
        {data.image || data.imageMobile ? (
          <Imagebox>
            {data.imageMobile && (
              <Source
                media={`(max-width: ${Breakpoints.sm}px)`}
                srcSet={data.imageMobile}
              />
            )}
            <Image
              theme={theme.widgetAdvertisement.image}
              src={data.image || data.imageMobile}
              loading='lazy'
              alt={data.title || ' '}
            />
          </Imagebox>
        ) : (
          ''
        )}
        {data.content
          ? htmlParser(
              DOMPurify.sanitize(data.content, {
                USE_PROFILES: { html: true },
                ADD_TAGS: ['iframe'],
                ADD_ATTR: [
                  'allow',
                  'allowfullscreen',
                  'frameborder',
                  'scrolling',
                  'target'
                ]
              })
            )
          : ''}
      </>
    );
  };

  return (
    <Wrapper>
      {data.slug || data.link || data.url || data.url_outside ? (
        <Content>
          {(data.slug && /(http(s?)):\/\//gi.test(data.slug)) ||
          (data.link && /(http(s?)):\/\//gi.test(data.link)) ||
          (data.url && /(http(s?)):\/\//gi.test(data.url)) ||
          data.url_outside ? (
            <ItemExternal
              ref={node => {
                styleRef(node);
                scriptRef(node);
              }}
              href={data.slug || data.link || data.url || data.url_outside}
              target={
                data._blank ||
                data.link_blank ||
                data.url_blank ||
                data.url_outside_blank
                  ? '_blank'
                  : '' || data.target || ''
              }
              rel={
                data.nofollow ||
                data.link_nofollow ||
                data.url_nofollow ||
                data.url_outside_nofollow
                  ? 'nofollow'
                  : '' || data.rel || ''
              }
            >
              {renderItemInner(data)}
            </ItemExternal>
          ) : data.slug || data.link ? (
            <Item
              ref={node => {
                styleRef(node);
                scriptRef(node);
              }}
              smooth
              to={(() => {
                let slug;
                if (data.slug)
                  slug = data.slug[0] === '/' ? data.slug : `/${data.slug}`;
                else if (data.link)
                  slug = data.link[0] === '/' ? data.link : `/${data.link}`;
                else slug = '';

                return slug;
              })()}
            >
              {renderItemInner(data)}
            </Item>
          ) : (
            ''
          )}
        </Content>
      ) : (
        <Content
          ref={node => {
            styleRef(node);
            scriptRef(node);
          }}
        >
          {renderItemInner(data)}
        </Content>
      )}
    </Wrapper>
  );
}

export default memo(WidgetAdvertisement);
